var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fb-comments-wrapper"},[_c('div',{staticClass:"fb-comments",attrs:{"data-href":_vm.dataHref,"data-order-by":"reverse_time","data-numposts":"10","data-width":"100%","width":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }